import Storage from '@/storage'
import { isIos } from '@/libs/utils'

export default {
  state: {
    userid: '',
    accountid: '',
    wechatSignUrl: '',
    personObj: {
      accountsexid: '',
      accountsexidNAME: '',
      acctname: '',
      birthday: '',
      cityid: '',
      cityidNAME: '',
      countyid: '',
      countyidNAME: '',
      iconimg: '',
      iconimgPATH: '',
      idcard: '',
      mobile: '',
      provinceid: '',
      provinceidNAME: '',
      unitname: '',
      isqyb: '',
      accounttype: ''
    },
    address: {
      ADDRESS: '',
      CITYID: '',
      CITYIDNAME: '',
      COUNTYID: '',
      COUNTYIDNAME: '',
      ID: '',
      ISDEFAULT: '',
      MOBILE: '',
      NAME: '',
      PROVINCEID: '',
      PROVINCEIDNAME: ''
    },
    userCertType: '', // 喜鹊门诊用户类型
    workerObj: {} // 职工小家工作人员信息
  },
  mutations: {
    setAccountid (state, accountid) {
      state.accountid = accountid
    },
    setAddress (state, address) {
      Object.assign(state.address, address)
    },
    setUserId (state, userid) {
      state.userid = userid
    },
    setPersonObj (state, personObj) {
      Object.assign(state.personObj, personObj)
    },
    setWechatSignUrl (state, wechatSignUrl) {
      // 关键点
      // IOS仅记录第一次进入页面时的URL
      // IOS微信切换路由实际URL不变，只能使用第一进入页面的URL进行签名
      if (isIos() && state.wechatSignUrl !== '') {
        return
      }
      state.wechatSignUrl = wechatSignUrl
    },
    setUserCertType (state, type) {
      state.userCertType = type
    },
    setWorkerObj (state, obj) {
      state.workerObj = obj
    }
  },
  getters: {
    getWechatSignUrl: state => state.wechatSignUrl
  },
  actions: {}
}
